import { render } from "./VueRedactor.vue?vue&type=template&id=af2d9be0"
import script from "./VueRedactor.vue?vue&type=script&lang=js"
export * from "./VueRedactor.vue?vue&type=script&lang=js"

import "./VueRedactor.vue?vue&type=style&index=0&id=af2d9be0&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__